import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { Switch, Route, withRouter, matchPath } from 'react-router-dom';

import './style.scss';

@withRouter @observer
export default class Tabs extends React.Component {
	
	static propTypes = {
		className: PropTypes.string,
	};
	
	@observable activeTab = 0;
	
	constructor(props) {
		super(props);
		React.Children.forEach(this.props.children, (child, i) => {
			const { path, exact } = child.props;
			const match = matchPath(document.location.pathname, { path, exact });
			if (match) this.activeTab = i;
		});
	}
	
	gotoTab = (index, tab) => {
		this.activeTab = index;
		this.props.history.push(tab.path);
	};
	
	render() {
		const tabs = [];
		
		React.Children.forEach(this.props.children, (child, i) => tabs.push(child.props));
		
		const titles = tabs.map((tab, i) => (
			<div
				key={i}
				className={'route-tab' + (i === this.activeTab ? ' active' : '')}
				onClick={() => this.gotoTab(i, tab)}>
				{tab.title}
			</div>
		));
		
		const routes = tabs.map((tab, i) => <Route key={i} path={tab.path} exact={tab.exact} render={() => tab.children}/>);
		
		const className = classNames('route-tabs', this.props.className);
		
		return <div className={className}>
			<div className="route-tabs-container">{titles}</div>
			<Switch>{routes}</Switch>
		</div>;
	}
	
}
